import { loadingView, unloadingView } from '../../../loader.js';
import Swiper, { Navigation, Autoplay, EffectFade, Thumbs } from 'swiper';
import FontFaceObserver from 'fontfaceobserver';
import "./../../../../node_modules/izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";


export default class Domdata {

    constructor(Parent) {
        this.dataParent = Parent;
    }


    closePicker() {
        console.log('[closePicker]');
        $('.IroColorPicker, .picker-close').remove();
        $('.picker').hide();
    }

    clickOnPicker(el) {
        console.log('[clickOnPicker]', 'data: ' + el.data('picker'), el);
        $('.picker').hide();
        $('#picker-' + el.data('picker')).html('').show();
        const dataParent = this.dataParent;
        let colorPicker;
        import(
            /* webpackChunkName: "iroColorPicker" */
            "./../../../components/iroColorPicker.js"
        ).then((iroColorPickerImport) => {
            colorPicker = iroColorPickerImport.init('#picker-' + el.data('picker'), dataParent);
            colorPicker.on('color:change', function (color) {
                // if the first color changed
                if (color.index === 0) {
                    switch (el.data('picker')) {
                        case 'belttext':
                            dataParent.class.Canvas.setColorText(color.hexString);
                            break;
                        case 'beltbackground':
                            dataParent.class.Canvas.setColorBelt(color.hexString);
                            break;
                        case 'picturebackground':
                            // dataParent.class.Canvas.setColorBelt(color.hexString);
                            dataParent.class.Canvas.addBackgroundColor(dataParent.storage.canvas, color.hexString);
                            break;
                        default:
                    }
                    dataParent.storage.canvas.renderAll();
                }
            });
        });

        if (dataParent.storage.mobile === false) {
            $('<div class="picker-close">Fermer</div>').appendTo('#picker-' + el.data('picker'));
            $('.picker-close').on('click', function () {
                console.log('click on close')
                dataParent.class.Dom.closePicker($(this));
            });
        }
    }




    async clickLoadStep(el) {

        let step = 0;
        if (isNaN(el) === true) {

            step = el.data('id_step');
        }
        else {
            step = el;
        }
        //console.log(typeof step);
        console.log('click on clickLoadStep', step);
        const res = await this.dataParent.class.Canvas.loadStepJsonCanvas(step);
        console.log('click load step ended', this.dataParent.storage);
    }

    async clickOnOrderTab(btnTab) {
        if (btnTab.hasClass('offline') === true) {
            return true;
        }
        const end_point = btnTab.data('action-tab');
        console.log('[clickOnOrderTab] end_point:', end_point)

        console.log(this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive]);
        const stepsDone = Object.keys(this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive]);


        //console.log('stepsDone', stepsDone);
        // CTRL IF ALL STEPS IS DONE
        // if (end_point === 'attributes-panel' && Math.abs(this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive].length - 1) < this.dataParent.storage.productData.interface.steps.nbstep && this.dataParent.storage.productData.interface.steps.nbstep == 2) {
        //     console.log('double face, ask question for duplicate face');
        //     $('.button-next').trigger('click');
        if (end_point === 'attributes-panel' && Math.abs(this.dataParent.storage.stepJsonCanvas[this.dataParent.storage.idProductActive].length - 1) < this.dataParent.storage.productData.interface.steps.nbstep) {


            // IF PROJECT IS 2 STEPS
            if (this.dataParent.storage.productData.interface.steps.nbstep == 2) {
                const resultChoice = await this.dataParent.class.Canvas.loadStepJsonCanvas(2);
                console.log('resultChoice', resultChoice);

                // IF STEP 2 IS EMPTY AND PUSH ON ADD TO CART
                if (resultChoice == 'new') {
                    console.log('resultChoice stopping to control', resultChoice);
                    return false;
                }
                //$('.button-next').trigger('click');
                //Populate.class.Dom.clickOnOrderTab($(this));

            }
            else {
                this.dataParent.class.Dom.messageAlert({
                    message: "Merci de compléter toutes les étapes de personnalisation.",
                    success: false
                });
            }

            let active_step;
            for (let i = 1; i <= this.dataParent.storage.productData.interface.steps.nbstep; i++) {
                active_step = '';
                if (parseInt(this.dataParent.storage.canvas.step) == i) {
                    active_step = 'active';
                }

                if (!stepsDone.includes(i.toString())) {

                    $('#steps').find('[data-id_step="' + i + '"]').css({ 'border-color': '#ff0000', color: '#FF0000' });
                }
            }

            // return false;
        }


        $('#bloc_custom .tab').removeClass('active');
        $('.panel').removeClass('active');
        btnTab.addClass('active');

        if (end_point == 'attributes-panel') {
            // console.log(loadAttributes($('#load-template').attr('data-id_product')));
            // ATTRIBUTE PANEL OK
            const json = await this.dataParent.class.Ajax.loadAttributes($('#load-template').attr('data-id_product'))
            console.log(json);
            let loadAttributes = '';
            $('.loadAttributes').html('');

            $(json.attributes).each((k, a) => {
                if (a.id_product_attribute) {
                    loadAttributes += `<div id="${a.id_product_attribute}" class="typeAttribute">`;
                    loadAttributes += `<div class="col-xs-4">${a.name}</div>`;
                    loadAttributes += '<div class="col-xs-8">';
                    loadAttributes += `<input class="qty" type="number" name="${a.id_product_attribute}" value="0" min="0" max="50" step="1" data-declinaison="${a.id_product_attribute}" maxlength="3" maxsize="3" value="0"/>`;
                    loadAttributes += '</div>';
                    loadAttributes += '</div>';
                }
            });

            $('.loadAttributes').html(loadAttributes);
            $('.loadAttributes').fadeIn('fast');

            const config = {
                decrementButton: '<strong>-</strong>', // button text
                incrementButton: '<strong>+</strong>', // ..
                groupClass: '', // css class of the input-group (sizing with input-group-sm or input-group-lg)
                buttonsClass: 'btn-outline-secondary',
                buttonsWidth: '3.5em',
                textAlign: 'center',
                autoDelay: 500, // ms holding before auto value change
                autoInterval: 100, // speed of auto value change
                boostThreshold: 10, // boost after these steps
                boostMultiplier: 'auto', // you can also set a constant number as multiplier
            };
            $("input[type='number']").inputSpinner(config);
            //$('.menu_custom').css('height', '100%');
            console.log('menu custom height 100%');
        }

        this.dataParent.class.Dom.openPanel(end_point);
    }

    /* COMMON */
    async clickCustomModify(el) {
        console.log("clickCustomModify");
        this.dataParent.class.Canvas.switchCanvas(el.closest("#AttributesLoadedModal").attr("data-id_product"));
    }

    async clickaddForeignProduct(el) {
        console.log("clickaddForeignProduct");

        // CTRL QTE
        let totalQty = 0;
        $("#AttributesLoadedModal")
            .find(".loadAttributes input[type=number]")
            .each(function () {
                totalQty = totalQty + $(this).val();
            });

        if (totalQty < 1) {
            this.dataParent.class.Dom.messageAlert({
                message: "Merci de choisir une quantité.",
                success: false
            });
            return false;
        }
        // CLOSE MODAL QTY POPUP
        $("#AttributesLoadedModal .close").click();

        const id_product = $("#AttributesLoadedModal").attr("data-id_product");
        console.log("id_product juste avant jsonsavecanvasdb " + id_product);

        // BLOCK BTN
        $("#othercustom-panel .order-txt").off().css("opacity", 0.5);


        const dataParent = this.dataParent;
        const canvastmp = await this.dataParent.class.Canvas.setCanvasTmp(dataParent.storage.stepJsonCanvas[id_product][1]);
        console.log('clickaddForeignProduct canvas', canvastmp);
        console.log('click load new canvas ended', this.dataParent.storage);

        loadingView(
            "customLoading",
            "create.svg",
            "Ajout de votre article complémentaire..",
            null
        );
        const json = await this.dataParent.class.Canvas.jsonSaveCanvasDB(canvastmp, id_product, $("#AttributesLoadedModal").find("#qtyPopup").serializeArray());
        console.log('jsonSaveCanvasDB json', json);
        //const result = await dataParent.class.Canvas.jsonSaveCanvasDB(dataParent.storage.canvas[id_product], id_product, $("#AttributesLoadedModal").find("#qtyPopup").serializeArray()).done(function (json) {
        if (json.success === true) {
            console.log(json);

            console.log("fini");
            $("#othercustom-panel .order-txt").on().css("opacity", 1);
        }
    }


    createCanvas(canvasName) {
        console.log('[createCanvas] => name ' + canvasName);
        const CanvasElement = $(`<canvas style="border: 2px solid #000000;" id="` + canvasName + `" class='other_canvas'></canvas>`);
        document.getElementById('wrapper_custom').appendChild(CanvasElement[0]);
        this.dataParent.storage.canvastmp = new fabric.Canvas(canvasName, {
            selection: false,
            preserveObjectStacking: true,
            stateful: true,
            overlayVpt: true,
            BackgroundVpt: true,
            noScaleCache: true,
            objectCaching: false,
        });
        let dynamicWidth = false;
        let dynamicHeight = false;
        if (this.dataParent.storage.mobile === false) {
            console.log('--- MOBILE FALSE ---');
            let wrapperCustomHeight = (($('#wrapper_custom').width() * 1769) / 2745);
            if (wrapperCustomHeight > $('.menu_custom').height()) {
                wrapperCustomHeight = $('.menu_custom').height();
                dynamicHeight = wrapperCustomHeight;
                dynamicWidth = ((2745 * wrapperCustomHeight) / 1749);
            } else {
                dynamicWidth = (($('#wrapper_custom').width() * wrapperCustomHeight) / wrapperCustomHeight);
                dynamicHeight = (1769 * dynamicWidth) / 2745;
            }
            this.dataParent.storage.canvastmp.setWidth(dynamicWidth);
            this.dataParent.storage.canvastmp.setHeight(dynamicHeight);
        }
        else {
            // FOR MOBILE
            this.dataParent.storage.canvastmp.setWidth($('#wrapper_custom').width());
            this.dataParent.storage.canvastmp.setHeight($('#wrapper_custom').width() / 1.551724137931034);
        }
    }


    async clickConfirmElement(el) {
        const id_product = $('#load-template').attr('data-id_product');

        const panel = el.closest('.panel').attr('id');
        console.log(`[clickConfirmElement] confirm panel ${panel}`);
        console.log('el', el);
        if (el.closest('.panel').hasClass('photo') === true) {
            this.dataParent.class.Dom.openSwiper('picture');
        }
        if (el.closest('.panel').hasClass('text') === true) {
            this.dataParent.class.Dom.openSwiper('text');
        }

        switch (panel) {
            case 'othercustom-panel':
                // REDIRECTION PANIER
                window.location.href = '/panier?action=show';
                break;

            case 'attributes-panel':
                // CTRL QTE
                let totalQty = 0;
                //console.log('typeattribute', $('.loadAttributes').find('.typeAttribute').attr('id'));
                $('.loadAttributes').find('input[type=number]').each(function (index, element) {
                    //console.log('index, element', index, element);
                    totalQty += $(element).val();
                    //console.log('el.val()', $(element).val());
                });


                console.log('nb step for ?', this.dataParent.storage.canvas);
                if (totalQty < 1) {
                    // alert('pb total qty');
                    this.dataParent.class.Dom.messageAlert({
                        message: "Merci de choisir une quantité.",
                        success: false
                    });
                    return false;
                }

                loadingView(
                    'customLoading',
                    'create.svg',
                    'Récupération de votre projet...',
                    null
                );

                // UPLOAD IMAGE
                const form = $('#form_personnalisation')[0];
                const file = $('#imageLoader_1')[0].files[0];

                const dataParent = this.dataParent;
                if (form != undefined && file != undefined) {
                    console.log('save with image');
                    // alert('save with image');
                    const json = await dataParent.class.Canvas.jsonSaveCanvasDB(
                        dataParent.storage.canvas,
                        id_product,
                        $('#attributes-panel').find('#qty').serializeArray()
                    );
                    if (json.success === true) {
                        // alert('image saved !');
                        // DOWNLOAD IMAGE WITH CUSTOMIZE ID
                        const data = new FormData();
                        let nbstepUploaded = 0;

                        // Collecter les fichiers du formulaire
                        for (var i = 1; i <= dataParent.storage.canvas.nbstep; i++) {
                            const fileInput = $('#imageLoader_' + i)[0];
                            if (fileInput.files[0] !== undefined) {
                                data.append('file_' + i, fileInput.files[0]);
                                nbstepUploaded++;
                            }
                        }

                        data.append('method', 'uploadImg');
                        data.append('id_product', $('#load-template').attr('data-id_product'));
                        data.append('id_personnalisation', json.id_personnalisation);
                        data.append('id_customization', json.id_customization);
                        data.append('nbstepUploaded', nbstepUploaded);

                        // Configuration de la barre de progression
                        if ($('.progress-container').length) {
                            console.log('progress container for image exist')
                        }
                        else {
                            console.log('progress container NOT exist')
                        }
                        const $progressContainer = $('.progress-container');
                        const $progressBar = $('#uploadProgress');
                        const $progressText = $('#progressText');

                        $('#SummaryText').text('Upload des images...');
                        // Initialiser la barre de progression et la rendre visible
                        $progressContainer.show();
                        $progressBar.val(0);
                        $progressText.text('0%');

                        // Envoi des données via jQuery AJAX
                        $.ajax({
                            type: 'POST',
                            url: `${prestashop.urls.base_url}modules/personnalisation/action.php`,
                            data,
                            cache: false,
                            processData: false,
                            contentType: false,
                            xhr: function () {
                                const xhr = $.ajaxSettings.xhr();
                                if (xhr.upload) {
                                    xhr.upload.addEventListener('progress', function (event) {
                                        if (event.lengthComputable) {
                                            const percentComplete = (event.loaded / event.total) * 100;
                                            $progressBar.val(percentComplete);
                                            $progressText.text(`${Math.round(percentComplete)}%`);
                                            console.log(`Progression : ${Math.round(percentComplete)}%`);
                                        }
                                    }, false);
                                }
                                return xhr;
                            },
                            success: function (jsonResponse) {
                                loadingView('personnalisation', 'create.svg', "Redirection Panier...");
                                window.location.href = '/panier?action=show';


                                // // UNIQUE PRODUCT
                                // if (Object.keys(dataParent.storage.products).length == 1) {
                                //     window.location.href = '/panier?action=show';
                                //     return true;
                                // }
                                // // Complément de produits
                                // dataParent.class.Canvas.createForeinProducts();
                            },
                            error: function (err) {
                                alert('Une erreur est survenue lors du téléchargement des fichiers.');
                                console.error(err);
                            },
                            complete: function () {
                                // Masquer la barre de progression une fois le téléchargement terminé
                                $progressContainer.hide();
                                unloadingView("customLoading");
                            }
                        });

                    }
                    // else {
                    //     alert('error json success save db', json.success);
                    // }

                    // alert('attribute finished');

                } else {
                    console.log('save without image');
                    console.log('jsonSaveCanvasDB before click', this.dataParent.storage.stepJsonCanvas);
                    const json = await this.dataParent.class.Canvas.jsonSaveCanvasDB(
                        this.dataParent.storage.canvas,
                        $('#load-template').attr('data-id_product'),
                        $('#attributes-panel').find('#qty').serializeArray()
                    );
                    console.log('result jsonSaveCanvasDB', json);
                    //.done((json) => {
                    if (json.success === true) {

                        loadingView('personnalisation', 'create.svg', "Redirection Panier...");
                        window.location.href = '/panier?action=show';


                        // UNIQUE PRODUCT
                        // if (Object.keys(this.dataParent.storage.products).length == 1) {
                        //     window.location.href = '/panier?action=show';
                        //     return true;
                        // }

                        // // COMPLEMENTARY PRODUCTS
                        // this.dataParent.class.Canvas.createForeinProducts();
                    }
                }
                break;

            case 'picture-panel':
                Populate.class.Dom.openSwiper('picture');
                break;


            case 'textbelt-panel':
                var texte = $('#input_txt_ceinture').val();

                if (texte.length > 0) {
                    if (this.dataParent.class.Dom.isEmoji(texte) === true) {
                        alert("Votre texte ne peut pas contenir d'émoticône via smartphone.");
                        break;
                    }
                    this.dataParent.class.Canvas.setTextInputOnCanvas($('#input_txt_ceinture').val(), this.dataParent.storage.canvas);
                    this.dataParent.class.Canvas.SelectObject(this.dataParent.storage.canvas, 'fabricObj_text');
                } else {
                    this.dataParent.class.Dom.deleteText();
                }
                this.dataParent.class.Dom.openSwiper('text');
                break;
        }

        if (this.dataParent.storage.productData.interface.panels.text.restrict.unique === true) {
            this.dataParent.storage.canvas.discardActiveObject();
        }
        this.dataParent.storage.canvas.renderAll();

        if (panel != 'attributes-panel' && panel != 'othercustom-panel') {
            this.dataParent.class.Dom.closePanel(panel, 'confirm');
        }
    }


    async clickIAPopup(el) {
        console.log("click clickIAPopup");

        // Vérifier si l'utilisateur est connecté
        const isConnected = typeof prestashop.customer !== 'undefined' && prestashop.customer.is_logged === true;

        const iaModal = $('#ia-modal');
        const modalBody = iaModal.find('.modal-body');

        // Affichage de la modal
        iaModal.modal('show').on('hidden.bs.modal', (event) => {
            // Actions après la fermeture de la modal, si nécessaire
        });

        if (!isConnected) {
            modalBody.html(`
                <center>
                <p>Vous devez être connecté pour accéder à notre Intelligence articielle.</p>
                </center>
            `);
        } else {
            modalBody.html(`
                <div id="ia-content">
                    <form id="image-radio-form" action="#">
                        <p>
                            <strong>Choisissez votre style :</strong>
                        </p>
                        <div id="style-ia" class="image-radio-group">
                            <div class="bloc">
                                <label class="image-radio-wrapper">
                                    <input type="radio" name="selected_image" value="realistic_image" checked>
                                    <img class="img-responsive" src="/modules/personnalisation/views/img/icons/ia/realistic_image.jpg" alt="Image 1">
                                </label>
                                <span>Photoréalisme</span>
                            </div>
                            <div class="bloc">
                                <label class="image-radio-wrapper">
                                    <input type="radio" name="selected_image" value="digital_illustration">
                                    <img class="img-responsive" src="/modules/personnalisation/views/img/icons/ia/digital_illustration.jpg" alt="Image 2">
                                </label>
                                <span>Illustration</span>
                            </div>                            

                            <div class="bloc">
                                <label class="image-radio-wrapper">
                                    <input type="radio" name="selected_image" value="pixel_art">
                                    <img class="img-responsive" src="/modules/personnalisation/views/img/icons/ia/pixelart.jpg" alt="Image 3">
                                </label>
                                <span>Pixel Art</span>
                            </div>                            

                            <div class="bloc">
                                <label class="image-radio-wrapper">
                                    <input type="radio" name="selected_image" value="hard_comics">
                                    <img class="img-responsive" src="/modules/personnalisation/views/img/icons/ia/hard_comics.jpg" alt="Image 4">
                                </label>
                                <span>Comics</span>
                            </div>                            

                            <div class="bloc">
                                <label class="image-radio-wrapper">
                                    <input type="radio" name="selected_image" value="handmade_3d">
                                    <img class="img-responsive" src="/modules/personnalisation/views/img/icons/ia/clay.jpg" alt="Image 5">
                                </label>
                                <span>Fait main</span>
                            </div>                            

                            <div class="bloc">
                                <label class="image-radio-wrapper">
                                    <input type="radio" name="selected_image" value="modern_folk">
                                    <img class="img-responsive" src="/modules/personnalisation/views/img/icons/ia/pixart.jpg" alt="Image 6">
                                </label>
                                <span>Pixar™</span>
                            </div>                            
                        </div>
                        <p id="text-choice">
                            <strong>Votre texte :</strong>
                            <br><br>Exemple : « 3 chatons s'amusant sur un canapé. »
                        </p>
                        <textarea id="ia-text" name="ia-text" cols="50" rows="4"></textarea>
                        <div class="modal-error" class="alert alert-danger d-none" role="alert"></div>
                    </form>
                </div>
            `);

            const form = document.getElementById('image-radio-form');
            const radioWrappers = document.querySelectorAll('.image-radio-wrapper');
            const submitButton = document.querySelector('.submit-btn');

            if (radioWrappers.length > 0) {
                const firstWrapper = radioWrappers[0];
                firstWrapper.classList.add('selected'); // Ajouter la classe 'selected' au premier
            }

            radioWrappers.forEach(wrapper => {
                wrapper.addEventListener('click', function () {
                    // Deselect all other radio wrappers
                    radioWrappers.forEach(w => w.classList.remove('selected'));

                    this.classList.add('selected');
                });
            });
        }
    }


    showModalError(message) {
        const errorDiv = document.querySelector(".modal-error");
        errorDiv.textContent = message;
        errorDiv.classList.remove("d-none");
        errorDiv.classList.add("show");
    }


    async clickIACreate(el) {
        console.log("click clickIACreate");

        const iaText = $('#ia-text');
        const errorDiv = document.querySelector(".modal-error");
        errorDiv.classList.add("d-none");
        errorDiv.classList.remove("show");

        var promptText = iaText.val();

        const dataParent = this.dataParent;
        loadingView('personnalisation', 'create.svg', "Génération ...", null, () => {

            const form = document.getElementById('image-radio-form');
            const selectedRadio = form.querySelector('input[type="radio"]:checked');
            let selected_image = '';
            if (selectedRadio) {
                selected_image = selectedRadio.value;
            }

            $.ajax({
                url: prestashop.urls.base_url + "module/personnalisation/recraft",
                method: 'POST',
                dataType: "json",
                data: {
                    token: prestashop.static_token,
                    generate_image: true,
                    prompt: promptText,
                    selected_image: selected_image
                },
                success: function (response) {
                    unloadingView('personnalisation');
                    console.log(response);
                    if (response.error) {
                        // Affichez le message d'erreur
                        dataParent.class.Dom.showModalError(response.error);
                    } else if (response.data[0].url) {
                        // Étape 1 : Enregistrer l'image sur le serveur
                        dataParent.class.Dom.saveImageToServer(response.data[0].url)
                            .then((savedImagePath) => {
                                // Étape 2 : Intégrer l'image au canvas avec fabric.js
                                dataParent.class.Canvas.addToCanvas(savedImagePath, dataParent.storage.canvas);
                                $('#ia-modal').modal('hide');
                            })
                            .catch((error) => {
                                dataParent.class.Dom.showModalError(error);
                            });
                    } else {
                        // Afficher tout autre message ou résultat
                        console.log(response.text || "Réponse inattendue.");
                    }

                },
                error: function () {
                    unloadingView('personnalisation');
                    dataParent.class.Dom.showModalError('Une erreur s\'est produite lors du traitement de votre demande.');
                }
            });
        });
    }


    // Fonction pour enregistrer l'image sur le serveur
    saveImageToServer(imageUrl) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: prestashop.urls.base_url + "module/personnalisation/saveiaimg",
                method: "POST",
                dataType: "json",
                data: {
                    image_url: imageUrl,
                    token: prestashop.static_token,
                },
                success: function (response) {
                    if (response.saved_path) {
                        resolve(response.saved_path); // Chemin de l'image enregistrée sur le serveur
                    } else {
                        dataParent.class.Dom.showModalError(response.error || 'Erreur inconnue lors de la sauvegarde.');
                        reject(response.error || 'Erreur inconnue lors de la sauvegarde.');
                    }
                },
                error: function () {
                    dataParent.class.Dom.showModalError("Erreur réseau lors de la sauvegarde de l'image.");
                    reject("Erreur réseau lors de la sauvegarde de l'image.");
                },
            });
        });
    }




    async clickVariationProduct(el) {

        console.log("click othercustom for size");
        //e.preventDefault();
        const id_product = el.data("id_product");

        const json = await this.dataParent.class.Ajax.loadAttributes(id_product)
        console.log(json);

        //loadAttributes(id_product).done(function (json) {
        console.log(json.product.name[1]);

        var html = "<div>Choisissez la taille et la quantité de " + json.product.name_short + " :<br></div>";
        //$("#AttributesLoaded").html("");
        $(json.attributes).each(function (k, a) {
            if (a.id_product_attribute) {
                html +=
                    '<div id="' + a.id_product_attribute + '" class="typeAttribute">';
                html += '<div class="col-xs-4">' + a.name + "</div>";
                html += '<div class="col-xs-8 qty">';
                html +=
                    '<input class="qty" type="number" name="' +
                    a.id_product_attribute +
                    '" value="0" min="0" max="50" step="1" data-declinaison="' +
                    a.id_product_attribute +
                    '" maxlength="3" maxsize="3" value="0"/>';
                html += "</div>";
                html += "</div>";
            }
        });

        $("#AttributesLoadedModal").find(".modal-title").html("Ajouter " + json.product.name[1]);
        $("#AttributesLoadedModal").find(".loadAttributes").html(html);
        var config = {
            decrementButton: "<strong>-</strong>", // button text
            incrementButton: "<strong>+</strong>", // ..
            groupClass: "", // css class of the input-group (sizing with input-group-sm or input-group-lg)
            buttonsClass: "btn-outline-secondary",
            buttonsWidth: "3.5em",
            textAlign: "center",
            autoDelay: 500, // ms holding before auto value change
            autoInterval: 100, // speed of auto value change
            boostThreshold: 10, // boost after these steps
            boostMultiplier: "auto", // you can also set a constant number as multiplier
            //locale: null // the locale for number rendering; if null, the browsers language is used
        };
        /*$("#AttributesLoadedModal")
          .find(".loadAttributes input")
          .InputSpinner(config);*/

        $("#AttributesLoadedModal").find(".loadAttributes").fadeIn("fast");
        $("#AttributesLoadedModal").attr("data-id_product", json.product.id);
        $("#AttributesLoadedModal").modal({
            backdrop: false,
            show: true,
        });
        $("input[type='number']").inputSpinner(config);
        console.log(json);
        // });

    }


    productInformation() {
        var info = "";
        console.log("[productInformation]");
        //Array.prototype.forEach.call(products, function (product)
        $.each(this.dataParent.storage.products, function (index, product) {
            if (parseInt(product.id) == parseInt($("#load-template").attr("data-id_product"))) {
                info = {
                    id: product.id,
                    productname: product.productname,
                };
            }
        });
        return info;
    };
    /* COMMON */


    createImgStepThumb(toStep, canvas) {
        console.log('[createImgStepThumb] {toStep, canvas}', toStep, canvas)
        if (toStep === undefined && canvas === undefined) {
            for (let i = 1; i <= this.dataParent.storage.productData.interface.steps.nbstep; i++) {
                //IF IMG DATA EXISTS
                if (this.dataParent.storage.thumbs[this.dataParent.storage.idProductActive][i]) {
                    // UPDATE IMAGE
                    $("#steps").find('.img_step_' + i).attr("src", this.dataParent.storage.thumbs[this.dataParent.storage.idProductActive][i]);
                }
            }
        }
        else {
            var img = canvas.toDataURL({
                format: "png",
                quality: 0.8,
            });
            // CREATE IMAGE
            $("#steps").find('.img_step_' + toStep).attr("src", img);
        }
    }



    arrSplit(arrValues) {
        var arr = arrValues.split(",");
        var w = new Number(arr[0]);
        var h = new Number(arr[1]);
        return [w, h];
    };

    updateLoading(message, id) {
        let idElement = $("#" + id);
        if (!idElement.length) {
            console.log("element non existant: " + id);
            $("#pourcent_chargement").append(
                '<div id="' + id + '">' + message + "</div>"
            );
        } else {
            //console.log("element  existant replace html on : " + id);
            $("#" + id).html(message);
        }
    };

    imageUploader(elIdName) {
        //document.getElementById('imageLoader').onchange = function handleImage(e) {
        // UPLOAD IMAGE
        const form = $('#form_personnalisation')[0];
        console.log($('#' + elIdName)[0]);
        const file = $('#' + elIdName)[0].files[0];

        console.log('form', form);
        console.log('file', file);
        if (form != undefined && file != undefined) {
            const data = new FormData();
            data.append('file', $('#' + elIdName)[0].files[0]);
            data.append('method', 'uploadImg');
            data.append('id_product', $('#load-template').attr('data-id_product'));

            loadingView(
                'customLoading',
                'create.svg',
                "Préparation de votre image...",
                null
            );

            console.log('+++++++++++++++++imageLoader_' + elIdName + ' on CHANGHE');
            const fileTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
            const extension = $('#' + elIdName)
                .val()
                .split('.')
                .pop()
                .toLowerCase();
            const isSuccess = fileTypes.indexOf(extension) > -1;

            if (isSuccess === false) {
                $('#' + elIdName).val('');
            }

            const dataParent = this.dataParent;
            if (window.FileReader && isSuccess) {
                const reader = new FileReader();
                reader.onload = function (event) {
                    dataParent.class.Canvas.setBackgroundImgToCanvas(dataParent.storage.canvas, {
                        imgSrc: event.target.result,
                        library: 0,
                        libraryName: '',
                    });
                    $('#img_externe').append(`<img class="img_library clipart-element" src="${event.target.result}">`);
                    unloadingView('customLoading');
                };

                reader.readAsDataURL($('#' + elIdName)[0].files[0]);
                if (
                    dataParent.storage.productData.interface.panels.picture.restrict.unique === true
                ) {
                    $('#photo-upload-txt').html('Modifier');
                }
                dataParent.class.Dom.closePanel('photo', 'confirm');
                $('.item_picture').removeClass('offline');
            } else {

                unloadingView('customLoading');
                dataParent.storage.notice.extension = iziToast.question({
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    displayMode: 'once',
                    id: 'question',
                    zindex: 999,
                    message: `l'extension "${extension}" de votre fichier image n'est pas supporté.<br><br>Extensions supportées : jpg, jpeg, png, gif, bmp`,
                    position: 'center',
                    buttons: [
                        [
                            "<button><b>J'ai bien compris</b></button>",
                            function (instance, toast) {
                                instance.hide(
                                    {
                                        transitionOut: 'fadeOut',
                                    },
                                    toast,
                                    'button',
                                );
                            },
                            true,
                        ],
                    ],
                });
            }

        }
    }


    openPanel(end_point, forcing) {
        console.log("[openPanel] {end_point, forcing}", end_point, forcing);
        $("#" + end_point).addClass("active");
        $(".green-arrow").show();

        if (this.dataParent.storage.mobile === true) {
            $('.menu_custom').css({
                'display': 'flex'
            });
        }

        this.dataParent.class.Dom.getActiveTab();

        $("#swiper-container-maskcolor").hide();
        $("#swiper-container-picture").hide();
        $("#swiper-container-text").hide();
        $("#swiper-container-sticker").hide();
        $("#swiper-container-mask").hide();
        $("#swiper-container-example").hide();
        //console.log("### -> openPanel " + end_point);
        console.log('this.dataParent.storage', this.dataParent.storage);

        //$('#' + end_point + ' .panel').css("display", "flex").hide().fadeIn('slow');

        if (this.dataParent.storage.mobile === true) {
            $(".panel").find("input[type=range]").hide();
            $("#" + this.dataParent.storage.tabActive + "-zoom").show();
            $("#" + this.dataParent.storage.tabActive + "-angle").show();
        }


        if (end_point == "attributes-panel" || end_point == "othercustom-panel") {
            if (this.dataParent.storage.mobile === true) {
                console.log('hide sliders othercustom - panel');
                $("#swiper-container-steps").hide();
                $("#sliders").hide();
                $("#wrapper_custom").hide();
                $("#productName").hide();
                $("header.christmas_shipping_msg").hide();
                $('#allsteps').hide();
            }
            //$("#" + end_point).css({
            //height: $("#bloc_custom").height(),
            //});
        }

        if (end_point === "mask-panel") {
            if (forcing !== true) {
                this.dataParent.class.Dom.openSwiper("mask");
                return true;
            }
        }

        if (end_point === "picture-panel") {
            if (forcing !== true) {
                this.dataParent.class.Dom.openSwiper("picture");
                return true;
            }
        }

        if (end_point === 'text-color-panel') {

        }


        if (end_point === "text-panel") {
            if (forcing !== true) {
                this.dataParent.class.Dom.openSwiper("text");
                return true;
            }
            var val = this.dataParent.class.Canvas.getTextFromObject(this.dataParent.storage.canvas, "fabricObj_text");
            if (this.dataParent.class.Canvas.getTextFromObject(this.dataParent.storage.canvas, "fabricObj_text") !== false) {
                $("#input_txt_ceinture").attr("value", val);
            }
            $("#swiper-container-text").css({
                display: "flex",
            });
        }

        if (end_point === "sticker-panel") {
            if (this.dataParent.storage.productData.interface.panels.sticker.restrict.addEmoji == true) {
                console.log("Init swiper #emojisSwiper");
                this.dataParent.storage.swiper["smiley"] = new Swiper("#emojisSwiper", {
                    slidesPerView: "auto",
                    slidesPerGroup: 5,
                    spaceBetween: 5,
                    loop: false,
                    grabCursor: true,
                    navigation: {
                        nextEl: ".emojisswiper-prev",
                        prevEl: ".emojisswiper-next",
                    },
                });
            }

            if (this.dataParent.storage.productData.interface.panels.sticker.restrict.addBubble == true) {
                console.log("Init swiper #bubblesSwiper");
                this.dataParent.storage.swiper["bubble"] = new Swiper("#bubblesSwiper", {
                    slidesPerView: "auto",
                    slidesPerGroup: 5,
                    spaceBetween: 5,
                    loop: false,
                    grabCursor: true,
                    navigation: {
                        nextEl: ".bubblesSwiper-next",
                        prevEl: ".bubblesSwiper-prev",
                    },
                });
            }

            if (forcing !== true) {
                this.dataParent.class.Dom.openSwiper("sticker");
                return true;
            }
        }

        if (end_point === "example-panel") {
            //$('#swiper-container-example').show();
            this.dataParent.class.Dom.openSwiper("example");
            return true;
        }

        $("#" + end_point).css({
            display: "flex",
            //width: $("#sliders").width(),
            //'height': ($(window).height() - 113 - 30) // 70 header + 43 h2
        });
        if (this.dataParent.storage.mobile === true) {
            $("#footer-custom").hide();
        }
    };

    closePanel(end_point, value) {
        console.log("### -> closePanel " + end_point);
        console.log("closePanel #value => " + value);

        this.dataParent.class.Dom.closePicker($(this));



        $(".panel").removeClass("active");
        $("#" + end_point).hide();

        console.log("tabActive " + this.dataParent.storage.tabActive);
        if (this.dataParent.storage.mobile === true) {
            $('.menu_custom').css({
                'display': 'none',
                // 'height': $('#footer-custom').height()
                'height': '150px'
            });

            $("#footer-custom, #sliders").show();

            if (end_point != "picture-panel" || end_point != "text-panel") {
                $("#wrapper_custom").show();
                $("#productName,.christmas_shipping_msg").show();
            }

            $("#" + this.dataParent.storage.tabActive + "-zoom").hide();
        }

        this.dataParent.class.Dom.openSwiper(this.dataParent.storage.tabActive);
    };


    updItems(objectType) {
        console.log('[updItems]', 'objectType : ' + objectType, this.dataParent.storage.canvas.step);
        const step = this.dataParent.storage.canvas.step;
        let textRestriction = this.dataParent.storage.productData.interface.panels.text.restrict;
        let stickerRestriction = this.dataParent.storage.productData.interface.panels.sticker.restrict;

        switch (objectType) {
            case 'text':
                console.log('textRestriction & step', textRestriction, step);
                textRestriction.addText[step] === true ? $('#insert-txt-btn').removeClass('offline') : $('#insert-txt-btn').addClass('offline');
                textRestriction.addLayer[step] === true ? $('#text-layerup').removeClass('offline') : $('#text-layerup').addClass('offline');
                textRestriction.addLayer[step] === true ? $('#text-layerdown').removeClass('offline') : $('#text-layerdown').addClass('offline');

                // MUST CRTL IF TEXT IS PRESENT !
                let textOnBelt = this.dataParent.class.Canvas.getObject(this.dataParent.storage.canvas, 'fabricObj_text', 'text');
                console.log('textOnBelt', textOnBelt);
                if (textOnBelt !== false) {
                    textRestriction.addTextColor[step] === true ? $('#color-picker-text').removeClass('offline') : $('#color-picker-text').addClass('offline');
                }
                textRestriction.addFont[step] === true ? $('#beltfonts').find('.item-action').removeClass('offline') : $('#beltfonts').find('.item-action').addClass('offline');
                textRestriction.addEmoji[step] === true ? $('#slide-txt-emoji,#txtsmiley-panel').find('.item-action').removeClass('offline') : $('#slide-txt-emoji,#txtsmiley-panel').find('.item-action').addClass('offline');
                break;

            case 'sticker':
                console.log('stickerRestriction & step', stickerRestriction, step);
                // stickerRestriction.addText[step] === true ? $('#insert-txt-btn').removeClass('offline') : $('#insert-txt-btn').addClass('offline');
                stickerRestriction.addLayer[step] === true ? $('#sticker-layerup').removeClass('offline') : $('#sticker-layerup').addClass('offlinedd');
                stickerRestriction.addLayer[step] === true ? $('#sticker-layerdown').removeClass('offline') : $('#sticker-layerdown').addClass('offline');
                // stickerRestriction.addTextColor[step] === true ? $('#color-picker-text').removeClass('offline') : $('#color-picker-text').addClass('offline');

                // stickerRestriction.addFont[step] === true ? $('#beltfonts').find('.item-action').removeClass('offline') : $('#beltfonts').find('.item-action').addClass('offline');
                stickerRestriction.addEmoji[step] === true ? $('#slide-sticker-emoji').find('.item-action').removeClass('offline') : $('#slide-sticker-emoji').find('.item-action').addClass('offline');
                break;
        }
    }

    activeItemsAction(objectType, status, elements) {
        console.log(`[activeItemsAction] {objectType, status, elements}`, objectType, status, elements);
        // console.log(status);
        this.getActiveTab();


        this.updItems(objectType);
        //if (this.dataParent.storage.tabActive == 'text' && objectType == 'sticker') return true;

        // DETECTION TYPE OBJET
        const o = this.dataParent.class.Canvas.getObjectFeature(this.dataParent.storage.canvas, objectType);
        //console.log(`detection object : ${o}`);
        //console.log(o);
        //console.log(this.dataParent.storage.canvas.id_canvas);
        if (objectType == 'example') {
            $('.order-tab').removeClass('offline');
        } else if (objectType == 'mask') {
            // setOverlay('2', canvasActive);
            // setOverlay('1', canvasActive);
        } else if (o.objectType) {
            console.log(`objectType exists : ${o.objectType}`);
            //console.log(`objectType exists : ${o.objectType}`, `#swiper-container-${this.dataParent.storage.tabActive} .item_${objectType}`);
            //$(`#swiper-container-${this.dataParent.storage.tabActive} .item_${objectType}`).removeClass('offline');            
            $(`.item_${objectType}`).removeClass('offline');
            if (status === false) {
                $(`#swiper-container-${objectType}`).find('.swiper-button-next').addClass('offline');
            }
            else {
                $(`#swiper-container-${objectType}`).find('.swiper-button-next').removeClass('offline');
            }

            $('#sliders .order-tab').css({
                display: 'flex',
            });
        } else {
            console.log('removed text +');

            $('#download').removeClass('offline');

            //$('#insert, #slide-sticker,#slide-emoji, #slide-bubble, #slide-backgroundcolor .swiper-slide').removeClass('offline');

            if (status === false) {
                // $(`.item_${objectType}.item-action`).addClass('offline');
            }

            // EXCEPTION FOR ADD TEXT
            //$(`.item_${objectType}.add`).removeClass('offline');

            $('#sliders .order-tab').css({
                display: 'flex',
            });
        }

        $("#sliders").find('.swiper').hide();
        $(`#swiper-container-${objectType}`).css({
            display: 'flex',
        });
        //}


        return true;
    };

    deleteText() {
        console.log('[deleteText]');

        if (this.dataParent.storage.productData.interface.panels.text.restrict.unique === true) {
            this.dataParent.class.Canvas.removeObject(this.dataParent.storage.canvas, 'fabricObj_text');
            // $('#insert-txt').html('Ajouter');
            $('#insert-txt-btn')
                .find('span')
                .addClass('add-text')
                .removeClass('edit-text');
            this.dataParent.class.Dom.activeItemsAction('text', false, 'add');
            this.dataParent.storage.canvas.optionsSelling.belt.use = false;
        } else {
            this.dataParent.class.Canvas.removeObject(this.dataParent.storage.canvas);
        }
        //this.dataParent.class.Dom.commandBtnUpdate(this.dataParent.storage.canvas);
        $('#input_txt_ceinture').val('');

        const beltBackground = this.dataParent.class.Canvas.getObject(this.dataParent.storage.canvas, 'fabricObj_belt', 'ceinture');

        if (beltBackground !== false) {
            beltBackground.set({
                fill: '#231F20',
            });
        }
    };

    moveGreenArrow(tab) {
        // console.log(`moveGreenArrow tab`, tab);
        const matched = $('#footer-custom').find('.tab');
        /* console.log(matched.length);
                    console.log(tab.position().left);
                    console.log(tab.width()); */
        const center = tab.position().left + tab.outerWidth() / 2;
        $('.green-arrow').css({ left: `${center}px` }).show();
    };

    openSwiper(swiperName) {
        console.log(`[openSwiper] ${swiperName}`);

        $('#footer-custom .tab').removeClass('active');
        $('#footer-custom').find(`.${swiperName}`).addClass('active');

        this.moveGreenArrow($(`.${swiperName}.tab`));
        this.activeItemsAction(swiperName);
        console.log('typeof this.dataParent.storage.swiper[swiperName]', typeof this.dataParent.storage.swiper[swiperName]);
        if (typeof this.dataParent.storage.swiper[swiperName] !== 'undefined') {
            this.dataParent.storage.swiper[swiperName].setTranslate(0);
            this.dataParent.storage.swiper[swiperName].update();
        }

        if (swiperName === 'picture') {
            if (!this.dataParent.storage.swiper['row-picture-colors']) {
                //console.log('Init swiper #boxercolors');
                this.dataParent.storage.swiper['row-picture-colors'] = new Swiper('#boxercolors', {
                    modules: [Navigation, Autoplay],
                    slidesPerView: 'auto',
                    // autoplay: {
                    //     delay: 2500,
                    //     disableOnInteraction: true,
                    //     pauseOnMouseEnter: true
                    // },
                    slidesPerGroup: 4,
                    spaceBetween: 5,
                    grabCursor: true,
                    loop: false,
                    freeMode: true,
                    freeModeMomentum: false,  // Pas d'inertie
                    resistanceRatio: 0,       // Pas de rebond aux bords
                    navigation: {
                        nextEl: '#boxercolorsnext',
                        prevEl: '#boxercolorsprev',
                    },
                });
                //console.log('swipers', this.dataParent.storage.swiper);
            }
            //this.dataParent.storage.swiper['row-picture-colors'].navigation.update();
            if (!this.dataParent.storage.swiper['row-picture-filters']) {
                //console.log('Init swiper #filtersSwiper');
                this.dataParent.storage.swiper['row-picture-filters'] = new Swiper('#filtersSwiper', {
                    modules: [Navigation, Autoplay],
                    slidesPerView: 'auto',
                    slidesPerGroup: 4,
                    spaceBetween: 5,
                    grabCursor: true,
                    loop: false,
                    navigation: {
                        nextEl: '.filtersswiper-next',
                        prevEl: '.filtersswiper-prev',
                    },
                });
            }
            //console.log(this.dataParent.storage.swiper);
        }

        if (swiperName === 'text') {
            if (this.dataParent.storage.productData.interface.panels.text.restrict.addFillColor == true) {
                if (!this.dataParent.storage.swiper['row-text-colors']) {
                    console.log('Init swiper #beltcolorsbackground');
                    this.dataParent.storage.swiper['row-text-colors'] = new Swiper('#beltcolorsbackground', {
                        modules: [Navigation, Autoplay],
                        slidesPerView: 'auto',
                        slidesPerGroup: 4,
                        spaceBetween: 5,
                        grabCursor: true,
                        loop: false,
                        navigation: {
                            nextEl: '.beltcolorsbackground-next',
                            prevEl: '.beltcolorsbackground-prev',
                        },
                    });
                }
            }

            if (this.dataParent.storage.productData.interface.panels.text.restrict.addEmoji[this.dataParent.storage.canvas.step] === true && !this.dataParent.storage.swiper['row-text-smileys']) {
                console.log('Init swiper #emojisTxtSwiper');
                this.dataParent.storage.swiper['row-text-smileys'] = new Swiper('#emojisTxtSwiper', {
                    modules: [Navigation, Autoplay],
                    slidesPerView: 'auto',
                    slidesPerGroup: 4,
                    spaceBetween: 5,
                    grabCursor: true,
                    loop: false,
                    navigation: {
                        nextEl: '.emojisTxtSwiper-next',
                        prevEl: '.emojisTxtSwiper-prev',
                    },
                });
            }
            // console.log('Init swiper #beltfonts1', this.dataParent.storage.productData.interface.panels.text.restrict.addFont);
            // console.log('Init swiper #beltfonts2', this.dataParent.storage.swiper['row-text-fonts']);
            if (this.dataParent.storage.productData.interface.panels.text.restrict.addFont[this.dataParent.storage.canvas.step] == true && !this.dataParent.storage.swiper['row-text-fonts']) {
                console.log('Init swiper #beltfonts');
                this.dataParent.storage.swiper['row-text-fonts'] = new Swiper('#beltfonts', {
                    modules: [Navigation, Autoplay],
                    slidesPerView: 'auto',
                    slidesPerGroup: 4,
                    spaceBetween: 5,
                    loop: false,
                    grabCursor: true,
                    navigation: {
                        nextEl: '.beltfonts-next',
                        prevEl: '.beltfonts-prev',
                    },
                });
            }
        }

        if (swiperName === 'sticker') {
            console.log(' SWIPER STICKER - NEW SWIPER + UPDATE');
            if (!this.dataParent.storage.swiper['row-sticker-smiley']) {
                console.log('Init swiper #emojisSwiper');
                this.dataParent.storage.swiper['row-sticker-smiley'] = new Swiper('#emojisSwiper', {
                    modules: [Navigation, Autoplay],
                    slidesPerView: 'auto',
                    slidesPerGroup: 4,
                    spaceBetween: 5,
                    loop: false,
                    grabCursor: true,
                    navigation: {
                        nextEl: '.emojisswiper-next',
                        prevEl: '.emojisswiper-prev',
                    },
                });
            }

            if (!this.dataParent.storage.swiper['row-sticker-bubble']) {
                console.log('Init swiper #bubblesSwiper');
                this.dataParent.storage.swiper['row-sticker-bubble'] = new Swiper('#bubblesSwiper', {
                    modules: [Navigation, Autoplay],
                    slidesPerView: 'auto',
                    slidesPerGroup: 4,
                    spaceBetween: 5,
                    loop: false,
                    grabCursor: true,
                    navigation: {
                        nextEl: '.bubblesSwiper-next',
                        prevEl: '.bubblesSwiper-prev',
                    },
                });
            }
        }

        if (swiperName === 'mask') {
            console.log('this.dataParent.storage.productData.interface.panels.mask.restrict.addFillColor', this.dataParent.storage.productData.interface.panels.mask.restrict.addFillColor);
            console.log('this.dataParent.storage.swiper[row-mask-colors]', this.dataParent.storage.swiper['row-mask-colors']);
            if (this.dataParent.storage.productData.interface.panels.mask.restrict.addFillColor == true && !this.dataParent.storage.swiper['row-mask-colors']) {
                /* swiper['row-mask-colors-free'] = new Swiper('#maskcolorsfree', {
                                                slidesPerView: 'auto',
                                                spaceBetween: 5,
                                                grabCursor: true,
                                                loop: true
                                            }); */
                console.log('Init swiper #maskcolors');
                this.dataParent.storage.swiper['row-mask-colors'] = new Swiper('#maskcolors', {
                    modules: [Navigation, Autoplay],
                    slidesPerView: 'auto',
                    spaceBetween: 5,
                    grabCursor: true,
                    loop: false,
                });
            }
        }

        if (swiperName === 'example') {
            const examples = this.dataParent.storage.productData.interface.panels.example.listing;

            if (this.dataParent.storage.mobile === true) {
                //console.log('is mobile')
                if ($("#swiper-container-example .swiper-wrapper").html() == "") {
                    examples.forEach(function (el) {
                        $("#swiper-container-example .swiper-wrapper").append(el);
                    });
                }

                this.dataParent.storage.swiper[swiperName].setTranslate(0);
                this.dataParent.storage.swiper[swiperName].update();
            }
            else {
                if ($('#swiper-container-example .examples').html() == '') {
                    examples.forEach((el) => {
                        $('#swiper-container-example .examples').append(el);
                    });
                }
            }


        }
        //this.commandBtnUpdate(this.dataParent.storage.canvas);
    };

    getActiveTab(lang = "") {
        console.log('[getActiveTab]');
        var tabType = $("#footer-custom").find(".tab.active").attr("class");

        if (typeof tabType !== "undefined") {
            var regex = /tab|col-[0-9]+|[ ]+|active/g;
            var tabName = tabType.replace(regex, "");
            if (lang == "lang") {
                return this.dataParent.storage.productData.interface.panels[tabName].title;
            }
            this.dataParent.storage.tabActive = tabName;
            return tabName;
        } else {
            console.log("getActiveTab not found inside => noActiveTab");
            return "noActiveTab";
        }
    };

    commandBtnUpdate(canvasName) {
        console.log('[commandBtnUpdate]');
        // POSSIBLE ACTION TO UNLOCK ORDER BUTTON
        if (
            this.dataParent.class.Canvas.getObject(canvasName, "fabricObj_sticker", 'smiley') !== false ||
            this.dataParent.class.Canvas.getObject(canvasName, "fabricObj_sticker", 'bubble') !== false ||
            this.dataParent.class.Canvas.getObject(canvasName, "fabricObj_sticker", 'sticker') !== false ||
            this.dataParent.class.Canvas.getObject(canvasName, "fabricObj_fond", 'picture') !== false ||
            (this.dataParent.class.Canvas.getObject(canvasName, "fabricObj_belt", 'ceinture') !== false &&
                this.dataParent.class.Canvas.getObject(canvasName, "fabricObj_belt", 'ceinture').fill != "#231F20") ||
            canvasName.backgroundColor != this.dataParent.storage.productData.interface.backgroundcolor ||
            this.dataParent.class.Canvas.getObject(canvasName, "fabricObj_text", 'text') !== false ||
            this.dataParent.class.Canvas.getObject(canvasName, "fabricObj_mask", 'picture') !== false
        ) {
            //console.log("BOUTON COMMANDE ok");
            $(".order-tab").removeClass("offline");
        } else {
            $(".order-tab").addClass("offline");
            //console.log("############################### OFFLINE .order-tab");
        }
    };



    //     const allRanges = document.querySelectorAll(".range-wrap");
    //     allRanges.forEach(wrap => {
    //         const range = wrap.querySelector(".range");
    //         const bubble = wrap.querySelector(".bubble");

    //         range.addEventListener("input", () => {
    //             setBubble(range, bubble);
    //         });
    // setBubble(range, bubble);
    //     });





    async observeNumeric(property, canvasName) {
        console.log('[observeNumeric]', property, canvasName);
        if (document.getElementById(property)) {
            const dataParent = this.dataParent;
            const rangeInput = document.getElementById(property);


            function setBubble(range, bubble) {
                console.log('bubble data', 'test:' + bubble.attr('data-test'));
                console.log('range id', range.attr('id'));

                const val = range.val();
                console.log('range val ', val);
                const min = range.attr('min');
                const max = range.attr('max');
                console.log('range min', min);
                console.log('range max', max);
                const newVal = Number(((val - min) * 100) / (max - min));
                console.log('range newVal', newVal);
                if (parseInt(val) > 0) {
                    bubble.html('+' + val + ' %');
                }
                else {
                    bubble.html(val + ' %');
                }


                // Sorta magic numbers based on size of the native UI thumb
                bubble.css({
                    'left': 'calc(${ newVal } % + (${ 8 - newVal * 0.15 }px))'
                });
            }


            rangeInput.oninput = function () {

                let value = parseInt(this.value);
                // Vérifier si l'élément est actif ou non
                if (
                    $(`#${property}`)
                        .closest('.right-block')
                        .parent('.swiper-slide')
                        .hasClass('offline') === true ||
                    $(`#${property}`)
                        .closest('.right-block')
                        .find('input[type=range]')
                        .hasClass('offline') === true
                ) {
                    console.log('observeNumeric: option not active');
                    return true;
                }

                setBubble($('#' + property), $('#' + property).closest('.range-wrap').find('output'));
                // Calcul du pourcentage à partir de la valeur actuelle
                // const min = parseFloat(rangeInput.min);
                // const max = parseFloat(rangeInput.max);
                // const value = parseFloat(rangeInput.value);

                // // Calcul du pourcentage pour le gradient
                // const percentage = ((value - min) / (max - min)) * 100;

                // console.log('valeur, this.value, percentage', value, this.value, percentage);

                // // Gradient dynamique : gris foncé de 0 à la position du curseur
                // rangeInput.style.background = `linear-gradient(to right, #333 ${percentage}%, #ddd ${percentage}%)`;

                // Gestion des propriétés canvas en fonction de la valeur
                const object = dataParent.class.Canvas.getObjectSystem(
                    dataParent.storage.canvas,
                    dataParent.storage.tabActive
                );

                if (property === 'picture-angle' || property === 'text-angle' || property === 'sticker-angle') {
                    dataParent.class.Canvas.setObject(object, {
                        angle: value,
                    });
                }

                if (property === 'picture-zoom' || property === 'text-zoom' || property === 'sticker-zoom') {
                    const scaleAdjustment = ((value + 100) / 100) * object.scaleXOriginal;
                    console.log('object', object);
                    console.log('object.scaleXOriginal', object.scaleXOriginal);
                    console.log('value', value);
                    console.log('((value + 100) / 100)', ((value + 100) / 100));
                    console.log('scaleAdjustment', scaleAdjustment);

                    dataParent.class.Canvas.setObject(object, {
                        scaleX: scaleAdjustment,
                        scaleY: scaleAdjustment,
                    });
                    dataParent.class.Canvas.onObjectScaled(object);
                }

                if (property === 'brightness') {
                    dataParent.class.Canvas.applyFilterValue(5, 'brightness', this.value);
                }
            };
        }
    }


    randomFont() {
        var fontRandom = Math.floor(Math.random() * this.dataParent.storage.fontsList.length);
        return fontRandom;
    }

    loadAndUse(font, obj, canvasName) {
        const dataParent = this.dataParent;

        import(
            /* webpackChunkName: "fonts" */
            "./loadfonts.js"
        ).then((loadFontsImport) => {
            loadFontsImport.loadFonts(font);
            var myfont = new FontFaceObserver(font);
            myfont
                .load(null, 10000)
                .then(function () {
                    // when font is loaded, use it.
                    if (font == "Roboto") {
                        font = "";
                    }
                    dataParent.class.Canvas.setObject(obj, {
                        fontFamily: font,
                    });
                    console.log('loadAndUse add font ' + font);
                    console.log('loadAndUse add font on object ', obj);
                    canvasName.requestRenderAll();
                })
                .catch(function (e) {
                    console.log(e);
                    //alert("font loading failed " + font);
                });
        });


    };

    isEmoji(message) {
        var emojiRegexp = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
        if (!message) return false;
        try {
            return message.match(emojiRegexp);
        } catch (err) {
            console.error("error in isEmoji" + err.stack);
        }
    };

    initInputSlide(object) {
        // ANGLE
        var angleInput = object.angle;
        console.log(object.angle);
        console.log(typeof object.angle);
        if (object.angle > 180) {
            angleInput = -Math.abs(object.angle - 360);
        }
        $("#" + object.objectType + "-angle").val(angleInput);
        console.log(
            "initInputSlide angleInput ON #" +
            object.objectType +
            "-zoom  value : " +
            angleInput
        );

        // ZOOM
        var zoomInput = (object.scaleX * 100) / object.scaleXOriginal - 100;
        $("#" + object.objectType + "-zoom").val(zoomInput);
        console.log(this.constructor.name + "- object.scaleX:" + object.scaleX);
        console.log("zoomInput:" + zoomInput);
        console.log(
            "initInputSlide zoomInput ON #" +
            object.objectType +
            "-zoom  value : " +
            zoomInput
        );
    };

    activeTextEditor(ObjectName, value) {
        //$('#beltcolors').find('.item-action').show();
        $("#boxercolors").find(".item-action").show();
        //$('#boxerfilters').find('.item-action').show();
        $("#beltfonts").find(".item-action").show();
        $("#emojisTxtSwiper").find(".item-action").show();
        $("#emojisSwiper").find(".item-action").show();
        $("#filtersSwiper").find(".item-action").show();

        $("#bubblesSwiper").find(".item-action").show();
        $(".swiper-container").show();
    };

    messageAlert(options) {
        console.log("[messageAlert]");


        console.log(options);
        var style = "#ffffff";
        if (options.success == true) {
            style = "#92FF6C";
        } else if (options.success == false) {
            style = "#FF8787";
        } else if (options.success == "warning") {
            style = "#FFA46C";
        }
        options.title = "";
        let size = 18;
        if (this.dataParent.storage.mobile === true) {
            size = '15';
        }
        iziToast.show({
            title: options.title,
            message: options.message,
            messageSize: size,
            position: "topRight",
            messageColor: style,
            backgroundColor: '#222222',
            progressBarColor: style,
            timeout: 5000,
            layout: 2,
            iconText: 'check_circle',
            balloon: false,
        });
    };


    /*compareTextObject(canvasName, ObjectName, value) {
        console.log("[getTextObject function]");
        var findedText = false;
        canvasName.getObjects().forEach(function (o) {
            //console.log("liste :"+o.name+" -> objet recherché :"+ObjectName);
            if (o.name == ObjectName && o.text == value) {
                console.log(
                    "Objet : " + o.name + " compare text => " + o.text + "  Ok"
                );
                findedText = true;
            }
        });
        return findedText;
    };*/
}